import React from "react";

export default function SVGLogo({ stroke = '#000', fill = '#000', className = 'icon' }): React.JSX.Element {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 31.74 5.292"
            xmlSpace="preserve"
        >
            <g
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(-54.49 -150)"
            >
                <g
                    fill={fill}
                    fillRule="nonzero"
                    strokeMiterlimit="10"
                    clipRule="evenodd"
                    transform="matrix(.0108 0 0 .0108 53.005 139.78)"
                >
                    <g
                        fill={fill}
                        fillRule="nonzero"
                        stroke={stroke}
                        strokeLinecap="butt"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    >
                        <path
                            d="M138.185 1346.97c0-27.61 22.386-50 50-50h226.208c27.614 0 50 22.39 50 50v39.8c0 27.62-22.386 50-50 50H188.185c-27.614 0-50-22.38-50-50z"
                            opacity="1"
                        ></path>
                        <path
                            d="M138.185 1172.22c0-27.62 22.386-50 50-50h389.312c27.615 0 50 22.38 50 50v39.8c0 27.61-22.385 50-50 50H188.185c-27.614 0-50-22.39-50-50z"
                            opacity="1"
                        ></path>
                        <path
                            d="M301.289 997.461c0-27.614 22.386-50 50-50h226.208c27.615 0 50 22.386 50 50v39.799c0 27.62-22.385 50-50 50H351.289c-27.614 0-50-22.38-50-50z"
                            opacity="1"
                        ></path>
                    </g>
                </g>
                <path
                    style={{ lineHeight: "0.9" }}
                    fill={fill}
                    strokeDasharray="1.92054, 1.92054"
                    strokeDashoffset="1.488"
                    strokeWidth="0.554"
                    d="M62.876 150q.377 0 .82.044.444.037.865.155l-.074.754q-.325-.014-.76-.022-.437-.007-.858-.007-.207 0-.355.015-.14.015-.229.059t-.126.148q-.037.096-.037.266 0 .259.119.377.125.118.421.214l.983.318q.613.207.85.562.236.354.236.93 0 .437-.103.725-.104.288-.325.45-.222.164-.584.23-.362.074-.887.074-.251 0-.717-.037-.466-.03-1.057-.163l.067-.798q.443.007.761.022.318.007.547.015h.399q.303 0 .466-.037.17-.037.236-.148.067-.11.067-.317 0-.185-.052-.289-.044-.103-.155-.17-.111-.066-.289-.118l-1.034-.355q-.591-.207-.835-.554-.237-.347-.237-.924 0-.436.104-.717.11-.28.332-.428.222-.155.577-.215.362-.059.864-.059zm3.651 1.545v2.402q0 .229.096.325.104.096.326.096.229 0 .45-.081.23-.09.57-.274l.08.599q-.398.34-.783.51-.377.17-.79.17-1.035 0-1.035-1.013v-2.734zm2.417 0v3.65h-.857l-.126-.716-.11-.104v-2.83zm2.143-.096q.392 0 .747.11.354.111.628.363l-.074.495q-.244-.074-.45-.126-.2-.059-.466-.059-.23 0-.37.081-.14.082-.207.318-.066.237-.066.702 0 .436.059.665.066.222.2.31.14.082.354.082.192 0 .333-.037.14-.044.28-.126.14-.088.326-.214l.074.54q-.222.31-.577.524-.355.207-.872.207-.702 0-1.005-.502-.296-.503-.296-1.441 0-.732.155-1.139.156-.414.459-.584.31-.17.768-.17zm2.27-1.427v5.174h-.866l-.11-.673-.119-.081v-2.395l.045-.103q-.022-.222-.037-.451-.008-.237-.008-.48v-.99zm2.63 1.427q.688 0 1.101.192.414.184.592.606.184.421.184 1.13 0 .695-.184 1.116-.178.422-.592.606-.413.185-1.1.185-.68 0-1.095-.185-.413-.184-.598-.606-.185-.42-.185-1.116 0-.709.185-1.13.185-.422.598-.606.414-.192 1.094-.192zm0 .79q-.28 0-.443.096-.163.097-.23.34-.066.244-.066.702 0 .444.067.688.066.244.229.34.162.088.443.088.288 0 .451-.088.163-.096.222-.34.066-.244.066-.688 0-.458-.066-.702-.06-.244-.222-.34-.163-.096-.45-.096zm6.157-.694l-.954 1.27q-.066.104-.17.2-.103.096-.17.14v.023q.067.044.17.163.104.11.17.229l1.08 1.626h-1.22l-1.25-2.055 1.124-1.596zm-2.44-1.523l.008 2.136q0 .259-.03.503-.03.243-.088.48.052.222.081.466.03.243.03.443v1.146h-1.087v-5.174zm.51 2.809v.665h-.85v-.665zm3.6-1.286v2.402q0 .229.096.325.103.096.325.096.23 0 .45-.081.23-.09.57-.274l.081.599q-.399.34-.783.51-.377.17-.79.17-1.036 0-1.036-1.013v-2.734zm2.417 0v3.65h-.858l-.125-.716-.111-.104v-2.83z"
                    aria-label="Sudoku"
                    fontFamily="Exo 2"
                    fontSize="27.933"
                    fontWeight="bold"
                ></path>
            </g>
        </svg>
    );
}
